import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Gallery = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M23 4H9C6.237 4 4 6.237 4 9V23C4 25.762 6.237 28 9 28H23C25.762 28 28 25.762 28 23V9C28 6.237 25.762 4 23 4ZM9 6H23C24.65 6 26 7.35 26 9V22.587L21.712 18.299C21.325 17.912 20.687 17.912 20.299 18.299L16.999 21.587L9.712 14.3C9.325 13.913 8.687 13.913 8.3 14.3L6 16.587V8.999C6 7.349 7.35 5.999 9 5.999V6ZM23 26H9C7.35 26 6 24.65 6 23V19.413L9 16.413L16.288 23.701C16.675 24.088 17.313 24.088 17.701 23.701L20.989 20.413L25.376 24.8C24.851 25.525 23.976 26 23.001 26H23Z" />
		<path d="M18 16C20.2 16 22 14.2 22 12C22 9.8 20.2 8 18 8C15.8 8 14 9.8 14 12C14 14.2 15.8 16 18 16ZM18 10C19.1 10 20 10.9 20 12C20 13.1 19.1 14 18 14C16.9 14 16 13.1 16 12C16 10.9 16.9 10 18 10Z" />
	</svg>
);

export default Gallery;
